/// <amd-module name="Comments/Editor/CommentEditor" />
export { CommentEditor } from "Comments/Editor/Components/CommentEditor";
export { ICommentEditorProps, IRenderEditorProps, IRenderedEditor } from "Comments/Editor/Components/CommentEditor.Props";
